<button class="version-button"
        (click)="onButtonClick($event)"
        [class.selected]="isSelected()">
    <div class="accent"
         [ngClass]="{ 'bg-green-500': versionType() == VersionType.Public,
                'bg-blue-500' : versionType() != VersionType.Public }"></div>
    <div class="flex items-center">
        @if (versionType() == VersionType.Draft) {
            <bizz-icon class="ml-auto mr-4 block h-8 w-8 text-default md:ml-0"
                       iconName="file-pen">
            </bizz-icon>
        } @else {
            <bizz-icon class="ml-auto mr-4 block h-8 w-8 text-default md:ml-0"
                       iconName="file-circle-check">
            </bizz-icon>
        }
        <div class="flex flex-col gap-1 justify-start">
            <h2 class="text-lg font-bold text-start">
                {{ (versionType() == VersionType.Draft ? 'DraftVersion' : 'PublicVersion') | translate }}
                @if (version()) {
                    <span class="absolute right-3 top-3 items-center justify-center gap-2.5 rounded-md bg-button px-2 py-1 text-center text-[14px] font-bold leading-none text-default">
                    {{ version() }}
                    </span>
                }
            </h2>
            <div class="flex flex-col">
                @if (versionDateStr()) {
                    <span class="text-xs text-start">
                        <span class="font-semibold mr-0.5">{{ 'VersionDate' | translate }}</span>
                        {{ versionDateStr() | datetime }}
                    </span>
                }
                @if (archiveDateStr()) {
                    <span class="text-xs text-red-400 text-start">
                        <span class="font-semibold mr-0.5">{{ 'WillBeArchivedOn' | translate }}</span>
                        {{ archiveDateStr() | datetime }}
                    </span>
                } @else {
                    <span class="invisible h-4"></span>
                }
            </div>
        </div>
    </div>
</button>